import React from "react";
import "./Button.scss";

// export default function Button({
//   children,
//   onClick,
//   type = "button",
//   disabled = false,
//   className = "",
//   color,
//   bg,
// }) {
//   return (
//     <button
//       style={{ color: color, backgroundColor: bg }}
//       type={type}
//       onClick={onClick}
//       disabled={disabled}
//       className={`ui-button ${disabled ? "disabled" : ""}`}
//     >
//       {children}
//     </button>
//   );
// }

export default function Button({
  children,
  onClick,
  type = "button",
  variant = "primary",
  className = "",
  disabled,
}) {
  return (
    <button
      disabled={disabled}
      type={type}
      onClick={onClick}
      id="def-button"
      className={`${variant} ${className}`}
    >
      {children}
    </button>
  );
}
